export const CREATE_PREPAYMENT_TRANSFER_REQUEST = "CREATE_PREPAYMENT_TRANSFER_REQUEST";
export const CREATE_PREPAYMENT_TRANSFER_SUCCESS = "CREATE_PREPAYMENT_TRANSFER_SUCCESS";
export const CREATE_PREPAYMENT_TRANSFER_FAIL = "CREATE_PREPAYMENT_TRANSFER_FAIL";

export const PREPAYMENT_TRANSFER_REQUEST = "PREPAYMENT_TRANSFER_REQUEST";
export const PREPAYMENT_TRANSFER_SUCCESS = "PREPAYMENT_TRANSFER_SUCCESS";
export const PREPAYMENT_TRANSFER_FAIL = "PREPAYMENT_TRANSFER_FAIL";

export const FIND_PREPAYMENT_TRANSFER_REQUEST = "FIND_PREPAYMENT_TRANSFER_REQUEST";
export const FIND_PREPAYMENT_TRANSFER_SUCCESS = "FIND_PREPAYMENT_TRANSFER_SUCCESS";
export const FIND_PREPAYMENT_TRANSFER_FAIL = "FIND_PREPAYMENT_TRANSFER_FAIL";

export const UPDATE_PREPAYMENT_TRANSFER_REQUEST = "UPDATE_PREPAYMENT_TRANSFER_REQUEST";
export const UPDATE_PREPAYMENT_TRANSFER_SUCCESS = "UPDATE_PREPAYMENT_TRANSFER_SUCCESS";
export const UPDATE_PREPAYMENT_TRANSFER_FAIL = "UPDATE_PREPAYMENT_TRANSFER_FAIL";

export const CLEAR_PREPAYMENT_TRANSFER_ERROR = "CLEAR_PREPAYMENT_TRANSFER_ERROR";